import React from 'react'
import { observer } from 'mobx-react'
import {
  Dialog,
  DialogHeader,
  DialogIllustration,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogButtonGroup,
  DialogButton,
} from 'components/Dialog'
import { match } from 'utils/pattern-match-util'
import ErrorBlock from 'components/ErrorBlock'
import { useBrandingSettings } from 'hooks/branding'

type StripeConnectPayoutModalState = 'pending' | 'error' | 'done'

interface StripeConnectPayoutModalProps {
  state: StripeConnectPayoutModalState
  onCloseRequest: () => void
  showing: boolean
  error?: unknown
}

export default observer(function StripeConnectPayoutModal({
  state,
  showing,
  onCloseRequest,
  error,
}: StripeConnectPayoutModalProps) {
  const { corporateMode } = useBrandingSettings()
  return (
    <Dialog showing={showing}>
      {match(state, {
        pending: () => (
          <>
            <DialogHeader>
              {!corporateMode && (
                <DialogIllustration
                  src={require('assets/images/img_stripe-connecting.svg')}
                />
              )}
              <DialogTitle>Connecting with Stripe</DialogTitle>
              <DialogDescription>
                We're finishing up connecting your account. Please wait while we
                finish that up for you.
              </DialogDescription>
            </DialogHeader>
          </>
        ),
        error: () => (
          <>
            <DialogHeader>
              {!corporateMode && (
                <DialogIllustration
                  src={require('assets/images/img_stripe-error.svg')}
                />
              )}
              <DialogTitle>Oops, something went wrong!</DialogTitle>
              <DialogDescription>
                We were not able to properly setup your Stripe account. Please
                try again or visit our Help Center to find out what could have
                happened.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter bordered>
              <ErrorBlock tackOn="bottom" error={error} />
              <DialogButtonGroup>
                <DialogButton onClick={() => onCloseRequest()}>
                  Close
                </DialogButton>
                {/* <DialogButton
                type="primary"
                onClick={vm.stripeConnectModalVM.close}
              >
                Visit Our Help Center
              </DialogButton> */}
              </DialogButtonGroup>
            </DialogFooter>
          </>
        ),
        done: () => (
          <>
            <DialogHeader>
              {!corporateMode && (
                <DialogIllustration
                  src={require('assets/images/img_stripe-success.svg')}
                />
              )}
              <DialogTitle>Stripe was successfully connected!</DialogTitle>
              <DialogDescription>
                You can now use it as your current payout method
              </DialogDescription>
            </DialogHeader>
            <DialogFooter bordered>
              <DialogButtonGroup>
                <DialogButton onClick={() => onCloseRequest()}>
                  Close
                </DialogButton>
              </DialogButtonGroup>
            </DialogFooter>
          </>
        ),
      })}
    </Dialog>
  )
})
